angular.module('TurneroApp').component('coCentrosAtencionAlta', {
    bindings: {
        ctrlPadre: '='
    },
    controller: [
        'centrosAtencionService',
        'domicilioService',
        'unidadService',
        '$location',
        '$anchorScroll',
        'utilsService',
        'TurneroAppConstant',
        function (centrosAtencionService, domicilioService, unidadService, $location, $anchorScroll, utilsService, TurneroAppConstant) {
            var ctrl = this;

            ctrl.permisos = TurneroAppConstant.Permisos;
            ctrl.centroAlta = {};
            ctrl.Unidades = [];
            ctrl.domicilio = null;
            ctrl.sinDomicilio = false;
            ctrl.zonas = {};

            ctrl.errores = {
                nombre: false,
                password: false,
                confirmacion: false,
                CUIT: false,
                calle: false,
                altura: false
            };

            ctrl.searchTermSede = {
                text: ''
            };
            ctrl.clearSearchTermSede = function () {
                ctrl.searchTermSede = {
                    text: ''
                };
            };

            ctrl.searchTerm = {
                text: ''
            };
            ctrl.clearSearchTerm = function () {
                ctrl.searchTerm = {
                    text: ''
                };
            };

            ctrl.$onInit = function () {
                ctrl.ctrlPadre.tLoadAlta = function () {
                    ctrl.centroAlta = {};
                    ctrl.Unidades = [];
                    ctrl.domicilio = null;
                    ctrl.sinDomicilio = false;

                    ctrl.errores = {
                        nombre: false,
                        password: false,
                        confirmacion: false,
                        CUIT: false,
                        calle: false,
                        altura: false
                    };

                    ctrl.CUITinfo = {
                        Id_Vin: "",
                        Encontrado: false
                    };

                    centrosAtencionService.getData({ 'Id_Centro_Atencion': '' }).$promise.then(function (data) {
                        ctrl.domicilio = null;
                        ctrl.centroAlta = data;
                        ctrl.centroAlta.Direccion = {}
                        ctrl.centroAlta.Direccion.Sede_Domicilio = {}
                        ctrl.centroAlta.Direccion.Id_Sede = data.Sede.Id_Sede
                        ctrl.centroAlta.Direccion.Id_Zona = data.Sede.Id_Zona
                        ctrl.centroAlta.Direccion.Sede_Domicilio.Calle = data.Sede.Sede_Domicilio.Calle
                        ctrl.centroAlta.Direccion.Sede_Domicilio.Altura = data.Sede.Sede_Domicilio.Altura
                        ctrl.centroAlta.Direccion.Sede_Domicilio.CP = data.Sede.Sede_Domicilio.CP
                        ctrl.centroAlta.Usa_Derivacion_Offline = 'N'
                        ctrl.centroAlta.Usa_Turno_Anonimos = 'N'
                        ctrl.centroAlta.Mostrar_Reloj = 'N'
                        ctrl.centroAlta.Clave_Autogestion = "";
                        ctrl.confirmarPassword = "";
                    }).catch(function (error) {
                        utilsService.errores(error)
                    });
                }
            }

            ctrl.buscarCUIT = function (CUIT, centroData) {
                CUIT = CUIT.replace(/-/g, "");
                if (centroData.grupoTipo == 'Empresa') {
                    ctrl.domicilio = null;
                    if (CUIT != "") {
                        ctrl.errores.CUIT = false;
                        domicilioService.getPersonaJuridica({ 'CUIT': CUIT }, function (data) {
                            centroData.Id_Unidad = null
                            for (var i = 0; i < data.Sedes.length; i++) {
                                var sede = data.Sedes[i]
                                data.Sedes[i].text = sede.Id_Sede + ' - ' + sede.Sede_Domicilio.Calle + ' ' + sede.Sede_Domicilio.Altura + ' ' + sede.Sede_Domicilio.Torre + ' ' + sede.Sede_Domicilio.Depto + '-  ' + (sede.Sede_Domicilio.Barrio != '' ? sede.Sede_Domicilio.Barrio + ',' : '') + ' ' + sede.Sede_Domicilio.Localidad;
                            }
                            ctrl.CUITinfo = data;
                            ctrl.CUITinfo.Encontrado = true;
                            ctrl.zonas = ctrl.obtenerZonas()
                            if (centroData.Sede) {
                                centroData = ctrl.ObtenerDomicilio(centroData.Sede, 'Empresa', centroData);
                            }

                        }, function (error) {
                            if (error = 'SIN DATOS') {
                                ctrl.errores.CUIT = true;
                            } else {
                                utilsService.errores(error);
                            }
                        });
                    } else {
                        sweetAlert("Oops...", "El campo CUIT no puede estar vacío", "error");
                    }
                }

                return centroData;
            }

            ctrl.buscarUnidad = function (text) {
                if (text != "") {
                    unidadService.get({ 'texto': text }, function (data) {
                        ctrl.Unidades = data;
                    }, function (error) {
                        sweetAlert("Oops...", "Algo ocurrió  y no se pudo completar la acción.<br/> Intente nuevamente o comuníquese con soporte. </br><span style='display:none'> " + error.data.ExceptionMessage + "</span>", "error");
                    });
                }
            };

            ctrl.ObtenerDomicilio = function (unidad, tipo, centroData) {
                ctrl.loading = true;
                if (unidad) {

                    if (tipo == 'Unidad') {

                        centroData.Id_Unidad = unidad.Id_Unidad;
                        centroData.N_Unidad = unidad.N_Unidad;
                        centroData.Sede = null;
                        centroData.CUIT = '';

                        if (unidad.Id_Domicilio) {
                            domicilioService.getDomicilio({ 'id_Vin': unidad.Id_Domicilio }, function (data) {

                                ctrl.sinDomicilio = false;
                                ctrl.domicilio = data;

                            }, function (error) {
                                ctrl.domicilio = null;
                                ctrl.Unidad = null;
                                utilsService.errores(error);


                            });
                        }
                        else {
                            ctrl.sinDomicilio = true;
                            ctrl.domicilio = null;
                        }
                    } else if (tipo == 'Empresa') {

                        centroData.Id_Unidad = null;
                        centroData.N_Unidad = null;

                        if (unidad.Sede_Domicilio != null) {
                            if (unidad.Sede_Domicilio.Calle) {
                                angular.forEach(centroData.Sede_Lista, function (el, k) {
                                    if (unidad.Id_Sede == el.Id_Sede) {
                                        ctrl.domicilio = el.Sede_Domicilio
                                    }
                                })
                            }
                        }
                    }

                }
                ctrl.loading = false;
                return centroData;
            }

            ctrl.agregarDerivaciones = function (item) {
                ctrl.centroAlta.Tipos_Deriv_in = '';
                angular.forEach(item, function (value, key) {
                    if (value == 'S') {
                        ctrl.centroAlta.Tipos_Deriv_in = ctrl.centroAlta.Tipos_Deriv_in + key + ',';
                    }
                });

                ctrl.centroAlta.Tipos_Deriv_in = ctrl.centroAlta.Tipos_Deriv_in.charAt(ctrl.centroAlta.Tipos_Deriv_in.length - 1) == ',' ?
                    ctrl.centroAlta.Tipos_Deriv_in.slice(0, -1) :
                    ctrl.centroAlta.Tipos_Deriv_in;
            }

            ctrl.guardarCentroNuevo = function () {
                ctrl.errores.nombre = !ctrl.centroAlta.N_Centro_Atencion;
                ctrl.errores.password = !ctrl.centroAlta.Clave_Autogestion;
                ctrl.errores.confirmacion = !ctrl.confirmarPassword;

                if (ctrl.errores.nombre || ctrl.errores.password) {
                    $location.hash('formCentro');
                    $anchorScroll();
                    return;
                }

                if (ctrl.confirmarPassword || ctrl.centroAlta.Clave_Autogestion) {
                    if (ctrl.confirmarPassword != ctrl.centroAlta.Clave_Autogestion) {
                        $location.hash('formCentro');
                        $anchorScroll();
                        ctrl.errores.confirmacion = true;
                        return;
                    }
                }

                ctrl.agregarDerivaciones(ctrl.tipoDerivaciones);

                centrosAtencionService.save(ctrl.centroAlta).$promise.then(function (res) {
                    ctrl.ctrlPadre.grillaReload();
                    sweetAlert("Alta Centro de Atención", "El centro de atención se registró correctamente", "success");
                }).catch(function (req) {
                    utilsService.errores(req);
                });

            }

            ctrl.cancelar = function () {
                ctrl.ctrlPadre.grillaReload();
            }
            ctrl.cargarDireccion = function (idSede){
                ctrl.CUITinfo.Sedes.forEach((sede)=>{
                    if(sede.Id_Sede == idSede){
                        ctrl.centroAlta.Direccion = {}
                        ctrl.centroAlta.Direccion.Sede_Domicilio = {}
                        ctrl.centroAlta.Direccion.Id_Sede = idSede
                        ctrl.centroAlta.Direccion.Id_Zona = sede.Id_Zona
                        ctrl.centroAlta.Direccion.Sede_Domicilio.Calle = sede.Sede_Domicilio.Calle
                        ctrl.centroAlta.Direccion.Sede_Domicilio.Altura = sede.Sede_Domicilio.Altura
                        ctrl.centroAlta.Direccion.Sede_Domicilio.CP = sede.Sede_Domicilio.CP
                    }
                })
            }

            function validarSede(centro) {
                if (centro.Direccion.Sede_Domicilio.Calle.trim().length === 0) {
                  ctrl.errores.calle = true;
                  ctrl.errores.altura = false;
                } else if (centro.Direccion.Sede_Domicilio.Altura.trim().length === 0) {
                  ctrl.errores.calle = false;
                  ctrl.errores.altura = true;
                } else {
                  ctrl.errores.calle = false;
                  ctrl.errores.altura = false;
                }
              }
              
              ctrl.editarSede = function () {
                validarSede(ctrl.centroAlta);
              
                if (!ctrl.errores.calle && !ctrl.errores.altura) {
                  centrosAtencionService.updateSede({
                    'id': ctrl.centroAlta.Direccion.Id_Sede,
                    'cuit': ctrl.CUITinfo.CUIT
                  }, ctrl.centroAlta.Direccion).$promise.then(function (data) {
                    sweetAlert('Modificar Sede', 'Se ha modificado la sede correctamente', 'success');
                    ctrl.buscarCUIT(ctrl.CUITinfo.CUIT, ctrl.centroAlta);
                  }).catch(function (error) {
                    utilsService.errores(error);
                  });
                }
              };
              
              ctrl.guardarSede = function () {
                validarSede(ctrl.centroAlta);
              
                if (!ctrl.errores.calle && !ctrl.errores.altura) {
                  centrosAtencionService.saveSede({ 'cuit': ctrl.CUITinfo.CUIT }, ctrl.centroAlta.Direccion).$promise.then(function (res) {
                    sweetAlert("Alta Sede", "La sede se registró correctamente", "success");
                    ctrl.centroAlta.Sede.Id_Sede = res.Data.Id;
                    ctrl.centroAlta.Direccion.Id_Sede = res.Data.Id;
                    ctrl.buscarCUIT(ctrl.CUITinfo.CUIT, ctrl.centroAlta);
                  }).catch(function (req) {
                    utilsService.errores(req);
                  });
                }
              };

            ctrl.obtenerZonas = function (){
                centrosAtencionService.getZonas().$promise.then(function (res){
                    ctrl.zonas = res.Data
                }).catch(function (error){
                    utilsService.errores(error)
                })
            }
        }
    ],
    template: require('./centrosAtencionAlta.html')
});


// WEBPACK FOOTER //
// ./app/components/centrosAtencion/centrosAtencionAltaComponent.js